import { Query } from '@jgile/laravel-vue';
import RevenueGoals from '@/teams/partials/RevenueGoals';

export default {
    name: 'reports-landing',
    components: {
        RevenueGoals,
    },
    props: {
        reports: {
            type: [Array, Object],
            default: () => [],
        },
    },
    data: () => ({
        runDate: null,
        savedReports: [],
        chartOptions: {
            tooltips: {
                enabled: false,
            },
            legend: {
                display: false,
            },
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        ticks: {
                            fontColor: '#35637E',
                        },
                        gridLines: {
                            display: false,
                            lineWidth: 2,
                            color: '#35637E',
                        },
                    },
                ],
                yAxes: [
                    {
                        display: false,
                    },
                ],
            },
        },
        quickReport: new Query({
            filters: {
                run_date: null,
            },
        }),
    }),
    methods: {
        deleteReport(id) {
            const self = this;
            swalc('Are you sure?', (confirm) => {
                if (confirm) {
                    axios.delete(`/api/reports/${id}`).then((response) => {
                        self.$set(self, 'savedReports', response.data.data);
                    });
                }
            });
        },
        gamedayReport() {
            this.quickReport.set({
                type: 'gameday',
                filters: {
                    run_date: [
                        _.get(this.spark, 'currentSchedule.start_date', moment().startOf('year')),
                        _.get(this.spark, 'currentSchedule.end_date', moment().endOf('year')),
                    ],
                },
            });
            window.location = this.quickReport.url('/team/reports/create');
        },
        categoryReport() {
            this.quickReport.set({
                type: 'asset_category',
                sort: '-total_revenue',
                fields: ['asset_category', 'total_revenue', 'number_advertisers', 'number_orders'],
            });
            window.location = this.quickReport.url('/team/reports/create');
        },
        businessReport() {
            this.quickReport.set({
                type: 'business_category',
                sort: '-total_revenue',
                fields: ['business_category', 'total_revenue'],
            });
            window.location = this.quickReport.url('/team/reports/create');
        },
    },
    watch: {
        reports: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.$set(this, 'savedReports', newVal);
            },
        },
        runDate(newVal) {
            window.location = new Query({ run_date: newVal }).url('/team/reports/create');
        },
    },
};
